var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLarge = function SvgLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 204 204"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#large_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002346",
    fillOpacity: 0.3,
    stroke: "#fff",
    strokeWidth: 0.5,
    d: "M109.901 8.648c51.48 4.504 89.562 49.888 85.058 101.367s-49.888 89.563-101.368 85.059S4.03 145.185 8.534 93.705 58.42 4.145 109.9 8.648Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "large_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.436.22 203.665 16.6 187.31 203.523.082 187.143z"
  })))));
};
export default SvgLarge;